import { render, staticRenderFns } from "./UpdateContentDialog.vue?vue&type=template&id=050ac955&scoped=true"
import script from "./UpdateContentDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateContentDialog.vue?vue&type=script&setup=true&lang=js"
import style0 from "./UpdateContentDialog.vue?vue&type=style&index=0&id=050ac955&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "050ac955",
  null
  
)

export default component.exports